export const FILE_SIZE_EXCEEDS_LIMIT = 8001;
export const UNDEFINED_PAGE_ERROR = 8002;
export const CODING_ERROR_OPTION_NOT_SUPPORTED = 8003;
export const USER_PROPERTIES_MISSING_IN_TOKEN = 8004;
export const USER_NOT_FOUND = 8005;
export const USER_PAGE_CREATE_FAILED = 8006;
export const SESSION_NOT_FOUND = 8007;
export const PAGES_NOT_FOUND = 8008;
export const FIRST_PAGE_NOT_FOUND = 8009;
export const MISSING_SESSION_ID = 8010;
export const METADATA_PAGE_CREATE_FAILED = 8011;
export const STALE_SESSION_STATE = 8012;
export const AT_LEAST_ONE_PAGE_REQUIRED = 8013;
export const UNKNOWN_ACTION_ERROR = 8014;
export const HTTP_REQUEST_ERROR = 8015;
export const NETWORK_ERROR = 8016;
export const UNKNOWN_ERROR = 8017;
